module.exports = __webpack_public_path__ + "img/filefj.70082e6e.svg";